var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditInvoiceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.11111 24.8889H5.32778L20.5333 9.68333L18.3167 7.46666L3.11111 22.6722V24.8889ZM0 28V21.3889L20.5333 0.894444C20.8444 0.609259 21.1882 0.388889 21.5647 0.233333C21.9411 0.0777779 22.3362 0 22.75 0C23.1638 0 23.5656 0.0777779 23.9555 0.233333C24.3455 0.388889 24.6825 0.622222 24.9667 0.933333L27.1055 3.11111C27.4167 3.3963 27.6438 3.73333 27.7869 4.12222C27.93 4.51111 28.001 4.9 28 5.28889C28 5.7037 27.929 6.09933 27.7869 6.47578C27.6448 6.85222 27.4177 7.19548 27.1055 7.50555L6.61111 28H0ZM19.4055 8.59444L18.3167 7.46666L20.5333 9.68333L19.4055 8.59444Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditInvoiceIcon);
export default __webpack_public_path__ + "static/media/EditInvoice-icon.cc0307a908ae455c2f019cab528c74e4.svg";
export { ForwardRef as ReactComponent };